<template>

    <main class="gmp-page gmp-page--no-newsletter">

        <PL_scondHero />
        <PL_highLights :clientWidth="clientWidth"/>
        <PL_twoTout />

        <div>Distributor</div>

    </main>

</template>


<script>
    import PL_scondHero from "../../components/content/market/overView/PL_scondHero";
    import PL_highLights from "../../components/content/market/overView/PL_highLights";
    import PL_twoTout from "../../components/content/market/overView/PL_twoTout";


    export default {
        name: 'Platform',
        components: {
            PL_scondHero,
            PL_highLights,
            PL_twoTout,
        },
        data() {
            return {
                clientWidth: "",
            }
        },

        mounted() {

            this.clientWidth = `${document.documentElement.clientWidth}`          //document.body.clientWidth;
            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.clientWidth = window.screenWidth
                })()
            }

        },
        methods: {

        }

    }
</script>

<style>


</style>
